<template>
  <div class="task-claim">
    <div>
      <div class="tips">申请人信息</div>
      <div class="creat-info">
        <div>申请人信息：{{ taskInfo.createby }}</div>
        <div>申请人职位：{{ taskInfo.creategw }}</div>
        <div>申请人部门：{{ taskInfo.createbm }}</div>
      </div>
    </div>
    <div>
      <div class="tips">任务模板附件</div>
      <el-table
        :max-height="height"
        :data="templateData"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="uploader"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="文件名称"
          align="left"
          prop="filename"
          min-width="300px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-link @click="openPreview(scope.row)" type="primary">{{
              scope.row.filename
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="操作"
          align="left"
          prop="name"
          min-width="80px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="downloadFile(scope.row)" type="primary"
                >下载</el-link
              >
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
    <div>
      <div class="tips">任务信息</div>
      <div>
        <el-form
          ref="form"
          :model="taskInfo"
          label-width="80px"
          class="clearfix"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务编号：" label-width="150px">
                <el-input disabled v-model="taskInfo.rwbh"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务标题：" label-width="150px">
                <el-input disabled v-model="taskInfo.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务所属条线：" label-width="150px">
                <el-input disabled v-model="taskInfo.txname"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务所属部门：" label-width="150px">
                <el-input disabled v-model="taskInfo.bmmc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务类型：" label-width="150px">
                <el-input disabled v-model="taskInfo.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务子类：" label-width="150px">
                <el-input disabled v-model="taskInfo.sun"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标准积分" prop="jf" label-width="150px">
                <el-input-number
                  v-model="taskInfo.jf"
                  :min="0"
                  :max="99999"
                  class="reward-input"
                  disabled
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="任务说明：" label-width="150px">
                <div id="wangEditor"></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="预期成果说明：" label-width="150px">
                <div id="wangEditor2"></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务结束时间：" label-width="150px">
                <el-input disabled v-model="taskInfo.jsrq"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计划总工时(人/日):" label-width="150px">
                <el-input disabled v-model="taskInfo.gs"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label=" 认领对象：" label-width="150px">
                <el-input disabled v-model="taskInfo.rldx"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="添加协作人：" label-width="150px">
                <el-radio-group v-model="xzrStatus" @change="handleChangeXzr">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="xzrStatus">
              <treeselect
                v-model="saveParams.ygbhs"
                :multiple="true"
                placeholder="请选择"
                :options="deptUser"
                :disable-branch-nodes="true"
                :show-count="true"
                value-consists-of="LEAF_PRIORITY"
                no-results-text="未搜到任何结果"
                :clear-on-select="true"
                :normalizer="normalizer"
                style="width: 100%"
                size="small"
              />
            </el-col>
          </el-row>
          <!-- <el-row v-if="user.isAdmin">
            <el-col :span="12">
              <el-form-item label="外部：" label-width="150px">
                <el-radio-group v-model="wbStatus" @change="handleChangeWb">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="wbStatus">
              <el-form-item label-width="0px">
                <el-input
                  v-model="saveParams.otheryg"
                  placeholder="请输入外部人员姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <el-form-item label=" 备注：" label-width="150px">
                <el-input
                  type="textarea"
                  v-model="taskInfo.bz"
                  rows="6"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import { getTaskAuditDetials, saveTaskRl } from "@/api/task.js";

export default {
  name: "taskClaim",
  computed: { ...mapGetters(["deptUser", "task", "user"]) },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      taskInfo: {},
      xzrStatus: 0,
      wbStatus: 0,
      templateData: [],
      saveParams: {
        taskId: null,
        ygbhs: [],
        otheryg: null,
        isAdmin: null,
      },
      parentDialog: false,
    };
  },

  created() {
    this.saveParams.taskId = this.mxParams.id;
    getTaskAuditDetials({ taskId: this.mxParams.id, type: 1 }).then((res) => {
      if (res.code == 0) {
        this.templateData = res.data.files;
        this.taskInfo = res.data.task;
        this.editor.txt.html(this.taskInfo.rwsm);
        this.editor2.txt.html(this.taskInfo.yqjg);
        this.xzrStatus = 0;
        this.wbStatus = 0;
      }
    });
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);
    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      // editor.config.uploadImgServer = window.g.apiUrl + '/common/uploadForumFile'
      // editor.config.uploadImgHeaders = {
      //   "x-token": localStorage.getItem("token"), // 设置请求头
      // };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      editor.disable();
      return editor;
    },
    handleChangeXzr(e) {
      this.xzrStatus = e;
      if (!e) {
        this.saveParams.ygbhs = [];
      }
    },
    handleChangeWb(e) {
      this.wbStatus = e;
      if (!e) {
        this.saveParams.otheryg = null;
      }
    },
    saveRwrl() {
      if (this.xzrStatus == 1 && this.saveParams.ygbhs.length == 0) {
        this.$message.error("请添加协作人");
        return;
      }
      if (this.wbStatus == 1 && !this.saveParams.otheryg) {
        this.$message.error("请输入外部人员姓名");
        return;
      }
      const params = {
        ...this.saveParams,
        ygbhs: this.saveParams.ygbhs.toString(),
      };
      saveTaskRl(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "task/fetchTaskListAction",
            this.task.taskList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
    downloadFile(row) {
      const filePath = row.url;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    openPreview(row) {
      const url = row.previewurl;
      window.open(url);
    },
  },
};
</script>
<style lang="less" scoped>
.creat-info {
  display: flex;
  justify-content: space-around;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
</style>